module.exports = __webpack_public_path__ + "assets/ecf4e503876a8f79499c0c121b19457a.mp4";